import { MouseEvent } from 'react'

import { createStyles } from 'antd-style'
import { isFunction, isNil } from 'lodash'

import { browserOpen } from '@eastcoal/common/utils/browser'

import { To, useNavigate } from '@eastcoal/router/exports/react-router'

import { ActionButton } from '../ActionButton'

import { NavigateButtonProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  button: {
    [`&.is-plain`]: {
      height: 'auto',
      padding: 0
    },
    [`&.is-underline > span`]: {
      textDecoration: `underline dashed`
    },
    [`&.${prefixCls}-btn-link`]: {
      [`&:disabled`]: {
        color: token.colorText,
        textDecoration: 'none',
        userSelect: 'text',
        cursor: 'default',
        [`&>span`]: {
          borderBottom: 'none'
        }
      }
    }
  }
}))

const resolveTo = (to?: To | (() => To | undefined | null)) => {
  if (isFunction(to)) {
    return to()
  }
  return to
}

export const NavigateButton = ({
  /* -------------------------------------------------------------------------- */
  /*                            NavigateButton Props                            */
  /* -------------------------------------------------------------------------- */
  underline,
  plain,

  /* -------------------------------------------------------------------------- */
  /*                               Navigate Props                               */
  /* -------------------------------------------------------------------------- */
  delta,
  to,
  replace,
  preventScrollReset,
  newtab,

  /* -------------------------------------------------------------------------- */
  /*                                ActionButton Props                          */
  /* -------------------------------------------------------------------------- */
  className,
  type = 'link',
  ...restProps
}: NavigateButtonProps) => {
  const navigate = useNavigate()

  const handleClick = (e: MouseEvent) => {
    if (to) {
      const _to = resolveTo(to)
      if (isNil(_to)) return
      // ctrl + click 打开新页面
      if (newtab || e.ctrlKey || e.metaKey) {
        browserOpen(_to.toString(), '_blank')
      } else {
        navigate(_to, { replace, preventScrollReset })
      }
    } else if (!isNil(delta)) {
      navigate(delta)
    }
  }

  const { cx, styles } = useStyles(underline)

  return (
    <ActionButton
      type={type}
      className={cx(styles.button, className, {
        [`is-underline`]: underline,
        [`is-plain`]: plain
      })}
      onClick={handleClick}
      {...restProps}
    />
  )
}
